<!--
 * @Author: v_aydwang
 * @Date: 2022-12-21 17:03:12
 * @LastEditors: v_aydwang
 * @LastEditTime: 2023-01-10 15:03:45
 * @Description: 大屏-基础档案弹窗
-->
<template>
<div class="mantle"  v-if="checkVisible">
  <div id="infoModal">
    <div class="title">基础档案</div>
    <div class="basic-archives">
      <div class="card-one">
        <p class="con">基础信息</p>
        <p><span>状态：</span>{{baseArchives.job_status || '-'}}</p>
        <p><span>供应商：</span>{{baseArchives.vendor || '-'}}</p>
        <p><span>结算供应商：</span>{{baseArchives.settle_supplier_code || '-'}}</p>
        <p><span>姓名：</span>{{baseArchives.nickname || '-'}}</p>
        <p><span>姓名拼音：</span>{{baseArchives.py_name || '-'}}</p>
        <p><span>年龄：</span>{{baseArchives.age || '-'}}</p>
        <p><span>性别：</span>{{baseArchives.gender || '-'}}</p>
        <p><span>用户ID：</span>{{baseArchives.user_id || '-'}}</p>
        <p><span>u_id：</span>{{baseArchives.u_id || '-'}}</p>
        <p><span>办公地：</span>{{baseArchives.office || '-'}}</p>
        <p><span>外包模式：</span>{{baseArchives.cooperate_way || '-'}}</p>
        <p><span>业务类型：</span>{{baseArchives.cooperate_type || '-'}}</p>
        <p><span>来源：</span>{{baseArchives.source || '-'}}</p>
        <p><span>身份证号：</span>{{baseArchives.id_num || '-'}}</p>
      </div>
      <div class="card-right">
        <div class="right-top">
          <div class="card-two">
            <p class="con">联系方式</p>
            <p><span>手机号：</span>{{baseArchives.phone || '-'}}</p>
            <p><span>qq号：</span>{{baseArchives.qq_number || '-'}}</p>
            <p><span>微信号：</span>{{baseArchives.wechat || '-'}}</p>
            <p><span>邮箱：</span>{{baseArchives.email || '-'}}</p>
          </div>
          <div class="card-three">
            <p class="con">学历信息</p>
            <p><span>学历：</span>{{baseArchives.edu || '-'}}</p>
            <p><span>专业：</span>{{baseArchives.major || '-'}}</p>
            <p><span>毕业院校：</span>{{baseArchives.school || '-'}}</p>
            <p><span>毕业时间：</span>{{baseArchives.graduate_time || '-'}}</p>
          </div>
        </div>
        <div class="card-four">
          <p class="con">生命周期</p>
          <div style="display: flex">
            <div class="four-left">
              <p><span>新老状态：</span>{{baseArchives.new_old || '-'}}</p>
              <p><span>在职时长(月)：</span>{{baseArchives.working_time || '-'}}</p>
              <p><span>入职时间：</span>{{baseArchives.entry_time || '-'}}</p>
              <p><span>入职培训时间：</span>{{baseArchives.train_time || '-'}}</p>
              <p><span>上岗时间：</span>{{baseArchives.mount_time || '-'}}</p>
              <p><span>预离职时间：</span>{{baseArchives.pre_quit_time || '-'}}</p>
            </div>
            <div>
              <p><span>离职时间：</span>{{baseArchives.quit_time || '-'}}</p>
              <p><span>离职原因：</span>{{baseArchives.quit_reason || '-'}}</p>
              <p><span>离职详情：</span>{{baseArchives.quit_detail || '-'}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot name="close"></slot>
  </div>
  </div>
</template>

<script>

export default {
  props: {
    checkVisible: {
      type: Boolean,
      default: false,
    },
    baseArchives: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    checkVisible(newVal) {
      if (newVal) {
        // this.getBaseArchives();
      }
    },
  },
  data() {
    return {

    };
  },
  methods: {
    getBaseArchives() {
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/convert-viewport";
.mantle {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}
#infoModal {
  position: absolute;
  padding: vw(20) vh(28);
  top: vh(58);
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: vw(1280);
  height: vh(680);
  background-image: linear-gradient(
    179deg,
    rgba(224, 236, 255, 0.9) 0%,
    rgba(202, 219, 255, 0.9) 100%
  );
  border: 1px solid #ffffff;
  box-shadow: 0 12px 12px 6px rgba(255, 255, 255, 0.16);
  border-radius: 20px;
  z-index: 1;
  .title {
    font-family: TencentSansW7;
    font-size: vw(24);
    color: #165bec;
    letter-spacing: 0;
    text-align: center;
    line-height: vh(36);
  }
  .basic-archives {
    display: flex;
    margin-top: vh(36);
    .card-one {
      width: vw(500);
      height: vh(557);
      background: url("~@/assets/personnel-large/card1.png") no-repeat;
      background-size: 100% 100%;
      margin-right: vw(20);
      padding: vh(20) 0 0 vw(36);
    }
    .right-top {
      display: flex;
      margin-bottom: vw(20);
      .card-two {
        width: vw(340);
        height: vh(230);
        background: url("~@/assets/personnel-large/card3.png") no-repeat;
        background-size: 100% 100%;
        margin-right: vw(20);
        padding: vh(20) 0 0 vw(36);
      }
      .card-three {
        width: vw(340);
        height: vh(230);
        background: url("~@/assets/personnel-large/card3.png") no-repeat;
        background-size: 100% 100%;
        padding: vh(20) 0 0 vw(36);
      }
    }
    .card-four {
      width: vw(700);
      height: vh(310);
      background: url("~@/assets/personnel-large/card4.png") no-repeat;
      background-size: 100% 100%;
      padding: vh(20) 0 0 vw(36);
      .four-left {
        width: 50%;
      }
    }
    .con {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: vw(16);
      color: #165bec;
      letter-spacing: 0;
      line-height: vh(24);
    }
    p {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: vw(14);
      color: #112a5a;
      letter-spacing: 0;
      line-height: vh(20);
      span {
        display: inline-block;
        width: vw(110);
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: vw(14);
        color: #41557b;
        letter-spacing: 0;
        line-height: vh(20);
      }
    }
  }
}
</style>
<style lang="less" scoped></style>
